<template>
  <el-row :gutter="8" class="hidden-md-and-down">
    <el-col v-if="rowData.organisation" :span="this.isManager() ? 14 : 23">
      <contacts-popover :row-data="rowData" />
    </el-col>

    <el-col v-if="isManager('maintenance') || isViewOnly()" :span="rowData.organisation ? 8 : 23">
    <el-button icon="fa fa-trash-alt"
    @click="deleteEntry()" size="small" type="danger" circle :disabled="isViewOnly()"></el-button>
    </el-col>
  </el-row>
  </template>

  <script>

  import PostMixins from '@/mixins/PostMixins'
  import ContactsPopover from '@/components/atoms/ContactsPopover'

  export default {
    mixins: [PostMixins],
    components: {
      ContactsPopover
    },

    props: {
      rowData: {
        type: Object,
        required: true
      },
      tableRef: {
        type: String,
        default: 'tickettable'
      }
    },
    methods: {
      deleteEntry () {
        let msg = this.rowData.organisation
          ? this.rowData.category + ' for ' + this.rowData.organisation.name
          : this.rowData.category

        this.deleteItem(this, this.rowData.id, '/tickets', msg, this.onDelete)
      },
      onDelete (response) {
        this.$events.fire(this.tableRef + '-refresh-table')
        this.$emit('update-stats')
      }
    }
  }
  </script>

  <style>
  .item {
    margin-top: 10px;
    margin-right: 40px;
  }
  </style>



// WEBPACK FOOTER //
// TicketControls.vue?34bea910